import Common from 'src/component/Global/Cart/Common';
import BOMRepository from "../../../../repository/BOMRepository";

class BomExactMatchValidation {
    bomDetail = {};

    constructor(bomDetail, price, inventory, CART_BEFORE_TO_SEND_SERVER) {
        this.bomDetail = bomDetail;
        this.price = price;
        this.inventory = inventory;
        this.CART_BEFORE_TO_SEND_SERVER = CART_BEFORE_TO_SEND_SERVER;
    }

    validatePartNumberForCart = () => {
        let status = null;
        let CART_BEFORE_TO_SEND_SERVER = this.CART_BEFORE_TO_SEND_SERVER;
        let ItemNumber = this.bomDetail.product.ItemNumber
        let inventory = this.inventory
        let price = this.price
        
        /**
         * Ticket #  : 7284
         * Change #  : For EOL / Obsolete Part add validation cases
         * Change by : Pankaj
         * Date      : 15 March 2023
         */
        if (CART_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            (CART_BEFORE_TO_SEND_SERVER[ItemNumber].ObsoleteFlag)) {
            // Case 1 : Inventory & No Price
            if (
                inventory &&
                Object.keys(inventory).length > 0 &&
                inventory.qas > 0 &&
                price &&
                Array.isArray(price) &&
                price.length === 0) {
                status = true;
            }
            // Case 2 : No Inventory & No Price
            // Note # : For this second case price we're not considering because if inventory is not present than 
            // EOL/Obsolete part is of no use so display error 
            if (
                inventory &&
                Object.keys(inventory).length > 0 &&
                inventory.qas === 0 &&
                price &&
                Array.isArray(price)) {
                status = true;
            }
        }
        if (CART_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            CART_BEFORE_TO_SEND_SERVER[ItemNumber].invalid_quantity !== undefined &&
            CART_BEFORE_TO_SEND_SERVER[ItemNumber].invalid_quantity === true
        ) {
            status = true;
        }

        // Qty Validation logic added
        if (this.bomDetail !== undefined &&
            this.bomDetail.product !== undefined &&
            this.bomDetail.quantity < this.bomDetail.product.QtyMin) {
            status = true;
        }
        if (this.bomDetail !== undefined &&
            this.bomDetail.product !== undefined &&
            this.bomDetail.quantity % this.bomDetail.product.QtyMult !== 0) {
            status = true;
        }

        //Make it last only
        if (status === null) {
            status = false;
        }
        return !status;
    }
    validatePartNumberForQuote = () => {
        let validQuoteResult = new BOMRepository().quoteValid(this.bomDetail);
        return validQuoteResult.isQuoteValid;
    }
    getDisplayStatusForAddToCart = () => {
        let CART_BEFORE_TO_SEND_SERVER = this.CART_BEFORE_TO_SEND_SERVER;
        let ItemNumber = this.bomDetail.product.ItemNumber
        if (CART_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            this.inventory &&
            this.price) {
            return new Common().getDisplayStatusOfAddToCart(this.price,
                CART_BEFORE_TO_SEND_SERVER[ItemNumber], this.inventory)
        }
        return false;
    }

    getDisplayStatusForContactUs = () => {
        let CART_BEFORE_TO_SEND_SERVER = this.CART_BEFORE_TO_SEND_SERVER;
        let ItemNumber = this.bomDetail.product.ItemNumber
        if (CART_BEFORE_TO_SEND_SERVER[ItemNumber] !== undefined &&
            this.inventory &&
            this.price) {
            return new Common().getDisplayStatusOfContactUsButton(false, this.inventory, CART_BEFORE_TO_SEND_SERVER[ItemNumber], this.price)
        }
        return false;
    }
}

export default BomExactMatchValidation;